/*
 * File: ModeofDeliveryInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 18 May 2021 5:02:37 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Select, Space, Spin, Typography } from 'antd';
import { CreateSalesOrderType } from 'common/enums/CreateSalesOrderType';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SalesOrderPayloadModel } from 'models/SalesOrderPayloadModel';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ReduxState } from 'redux/rootReducer';
import { useGetModesOfDeliveryQuery } from 'redux/services/useGladysTheCowService';
import { BlockLoader } from '../BlockLoader';
const { Title } = Typography;

const styles: InlineStylesModel = {
  selectInput: {
    width: '100%'
  },
  titleColor: {
    color: '#2F5596'
  }
};

export const ModeofDeliveryInput = (): JSX.Element => {
  const { values, setFieldValue } = useFormikContext<SalesOrderPayloadModel>();
  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');

  const { selectedCompanyDataAreaId: dataAreaId } = useSelector((state: ReduxState) => state.salesOrders);

  const [inputValue, _setInputValue] = useState<string | undefined>(undefined);
  const [offset, _setOffset] = useState(0);

  /* ****************** Hook API ****************** */
  const { data: modesOfDeliveryResponse, isFetching, isLoading } = useGetModesOfDeliveryQuery({ dataAreaId, modeOfDeliveryContains: inputValue, offset });

  /* ****************** JSX / Variables ****************** */
  const modesOfDeliverySearchOptions = useMemo(() => modesOfDeliveryResponse?.data?.map((mode) => ({ label: mode.modeCode, value: mode.modeCode })), [modesOfDeliveryResponse]);

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  // const handleSearch = useDebouncedCallback((value: string | undefined) => {
  //   _setOffset(0);
  //   _setInputValue(value);
  // }, 600);

  const handleClear = (): void => {
    _setInputValue(undefined);
    _setOffset(0);
    setFieldValue('modeOfDelivery' as keyof SalesOrderPayloadModel, null);
  };

  // const handleScroll = (event: React.UIEvent<HTMLDivElement>): void => {
  //   const target = event.currentTarget;

  //   if (!isLoading && !isFetching && target.scrollTop + target.offsetHeight === target.scrollHeight && modesOfDeliveryResponse && modesOfDeliveryResponse?.totalCount - offset > 25) {
  //     _setOffset((prevState) => prevState + 25);
  //   }
  // };

  const handleSelect = (value: string): void => {
    setFieldValue('modeOfDelivery' as keyof SalesOrderPayloadModel, value);
    _setInputValue(undefined);
  };

  const dropDownRender = (menu: JSX.Element): JSX.Element => {
    if ((isLoading || isFetching) && !offset)
      return (
        <div style={{ textAlign: 'center', padding: 10 }}>
          <Spin indicator={<BlockLoader direction="loader loader--slideUp" />} spinning />
        </div>
      );

    const moreResultsJSX =
      (isLoading || isFetching) && offset ? (
        <div style={{ padding: '0px 10px' }}>
          <Space>
            <Spin size="small" indicator={<BlockLoader direction="loader loader--slideUp" />} />
          </Space>
        </div>
      ) : null;

    return (
      <div>
        {menu}
        {moreResultsJSX}
      </div>
    );
  };

  /* ****************** Render ****************** */
  return (
    <>
      <Title level={5} style={styles.titleColor}>
        {CreateSalesOrderType.MODE_OF_DELIVERY}
      </Title>
      <Select
        allowClear
        value={values.modeOfDelivery}
        dropdownRender={dropDownRender}
        disabled={isPosted}
        // filterOption={false}
        filterOption={(input, option): boolean => (option?.value as unknown as string).toLowerCase().includes(input.toLowerCase())}
        loading={isLoading || isFetching}
        onClear={handleClear}
        // onPopupScroll={handleScroll}
        // onSearch={handleSearch}
        onSelect={handleSelect}
        options={modesOfDeliverySearchOptions}
        showSearch
        style={styles.selectInput}
      />
    </>
  );
};
